import React, { FC, ReactNode } from 'react'
import { TextBox, Text, Media, Box } from '@revolut/ui-kit'

type Row = {
  description: string | ReactNode
  value?: string
}

export type DetailsSectionType = {
  title: string
  sectionRows: Row[]
} & React.ComponentPropsWithoutRef<typeof Box>

export const DetailsSection: FC<DetailsSectionType> = ({
  title,
  sectionRows,
  ...rest
}) => {
  if (!sectionRows.length) {
    return null
  }
  return (
    <Box {...rest}>
      <TextBox color='black' fontWeight={500} alignSelf='flex-start'>
        {title}
      </TextBox>
      {sectionRows.map((row, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Media minWidth='100%' mt='1rem' key={index}>
          <Media.Content>
            <Text color='grey-50'>{row.description}</Text>
          </Media.Content>
          <Media.Side>
            <Text color='black'>{row.value}</Text>
          </Media.Side>
        </Media>
      ))}
    </Box>
  )
}
